export const RESIZE_CONFIG = {
    maxRowsToCheck: 1000,
    padding: 60,
    minWidth: 60,
    maxWidth: 450,
    lastColumnExtraPadding: 32
}